export default () => ({

    videoPlayed: false,
    openVideoModal: false,

    closeVideoModal() {
        var video = this.$refs.modalVideo;
        video.pause();
        this.openVideoModal = false;
        this.videoPlayed = false;
    },

    playVideo() {
        var video = this.$refs.modalVideo;
        if (video) {
            video.play();
            this.videoPlayed = true;
        }
    }

})